<template>
  <div>
    <!-- 产品分类导航 start -->
    <productSub></productSub>
    <!-- 产品分类导航  end  -->

    <!-- content - start -->
    <div class="productbox content">
      <div class="banner-sub">
        <img :src="background.banner" alt="">
      </div>
      <div class="products bg">
        <div class="wrap">
          <div class="title">
            <h2>产品推荐</h2>
            <span></span>
          </div>
          <div class="box-products product-page">
            <template v-for="(item, idx) in productList">
              <div @click="productDetailHandler(item.id)" :key="idx" :class="'item' + idx" v-if="idx < 7"
                class="item-com">
                <div class="img-com">
                  <img class="img-cover" :src="item.img" alt="">
                </div>
                <div class="i-bg"></div>
                <div class="con">
                  <h3>{{ item.title }}</h3>
                  <p class="ellipsis">{{ item.introduction }}</p>
                </div>
              </div>
            </template>
          </div>
        </div>
      </div>
      <div class="product-demo mt80">
        <!-- <img class="imgbg" :src="background.project" alt=""> -->
        <div class="product-demo-txt">
          <div class="wrap">
            <div class="title">
              <h2>更多产品</h2>
              <span></span>
            </div>
            <div class="product-demo-list">
              <div class="swiper-container swiper-product-box">
                <div class="swiper-wrapper" v-if="productAllList && productAllList.length > 0">
                  <div v-for="(item,index) in productAllList" :key="index" @click="productDetailHandler(item.id)"
                    class="swiper-slide product-demo-list-item">
                    <div class="swiper-img">
                      <div class="img-com">
                        <img class="imgbg" :src="item.imgUrl" alt="">
                      </div>
                    </div>
                    <div class="swiper-txt">
                      <span>{{ item.title }}</span>
                      <p>{{ item.createTime }}</p>
                    </div>
                  </div>
                </div>
                <!-- Add Pagination -->
                <div class="swiper-pagination"></div>
                <!-- Add Arrows -->
                <div class="swiper-button-next"></div>
                <div class="swiper-button-prev"></div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="products bg">
        <div class="wrap">
          <div class="title">
            <h2>成功案例</h2>
            <span></span>
          </div>
        </div>
        <div class="productImg">
          <img class="imgbg" :src="background.project" alt="">
        </div>
      </div>
      <!-- 底部轮播 -->
      <div class="project-box">
        <div class="swiper-container swiper-project-box">
          <div class="swiper-wrapper">
            <div v-for="(item,index) in projectList" :key="index" class="swiper-slide" @click="projectDetailHandler(item.id)">
              <div class="pro-swiper-item">
                <div class="pro-img">
                  <img class="imgbg" :src="item.img" alt="">
                  <p>{{item.title}}</p>
                  <div class="bg"></div>
                </div>
                <div class="pro-txt-box">
                  <p v-html="item.detail"></p>
                </div>
              </div>
            </div>
          </div>
          <!-- Add Pagination -->
          <div class="swiper-pagination"></div>
          <!-- Add Arrows -->
          <div class="swiper-button-next"></div>
          <div class="swiper-button-prev"></div>
        </div>
      </div>
    </div>
    <!-- content - end -->
  </div>
</template>

<script>
import { ApiWebProjectIndex, ApiWebProjectBackground, ApiWebProductList } from '../api/product'
import productSub from './product-sub.vue'

export default {
  name: 'product',
  data () {
    return {
      subNavFlag: false,
      // 记录当前导航菜单 菜单类型 1-软件产品、2-硬件产品、3-成功案例、4-解决方案
      navType: 1,
      // 副导航菜单list
      leftMenuNav: [],
      menuList: [],
      subMenuList: [],
      // 推荐产品列表
      productList: [],
      // 左右产品列表
      productAllList: [],
      // 方案列表
      projectList: [],
      // 产品和方案背景图
      background: {
        banner: null,
        project: null,
        product: null
      }
    }
  },
  components: {
    productSub
  },
  created () {
    this.initProductList()
    this.getProductListAll()
    this.initBackground()
  },
  methods: {
    /**
     * 获取所有产品list
     */
    getProductListAll() {
      ApiWebProductList().then(({ data }) => {
        if (data && data.status === 0) {
          this.productAllList = data.data.list
          this.$nextTick(() => {
            var swiper = new Swiper('.swiper-product-box', {
              // pagination: '.swiper-pagination',
              nextButton: '.swiper-button-next',
              prevButton: '.swiper-button-prev',
              slidesPerView: 3,
              centeredSlides: true,
              loopFillGroupWithBlank: true,
              spaceBetween: 25,
              loop: true
            })
          })
        }
      })
    },
    /**
     * 点击菜单事件
     * @param id 菜单id
     * @param idx 菜单下标
     */
    leftNavClick (id, idx) {
      this.navType = id
      this.menuList = this.leftMenuNav[idx].children
    },
    /**
     * 软件产品、硬件产品  点击产品分类
     * idx 数组下标
     */
    productTypeHandler (idx) {
      this.subMenuList = this.leftMenuNav[0].children[idx].children
    },
    toNewsInfo (id) {
      this.$router.push({ name: 'newsDetail', params: { newsId: id } })
    },
    /**
     * 查询产品信息
     */
    initProductList () {
      ApiWebProjectIndex().then(({data}) => {
        if (data && data.status === 0) {
          this.productList = data.data.recommend
          this.projectList = data.data.project
          this.leftMenuNav = data.data.menu
          this.navType = this.leftMenuNav[0].id
          this.menuList = this.leftMenuNav[0].children
          this.subMenuList = this.leftMenuNav[0].children[0].children

          this.$nextTick(() => {
            var swiper = new Swiper('.swiper-project-box', {
              // pagination: '.swiper-pagination',
              nextButton: '.swiper-button-next',
              prevButton: '.swiper-button-prev',
              slidesPerView: 6,
              centeredSlides: true,
              loopFillGroupWithBlank: true,
              spaceBetween: 25,
              loop: true
            })
          })
        }
      })
    },
    /**
     * 点击产品菜单跳转页面
     * @param id 产品id
     */
    productDetailHandler (id) {
      this.$store.commit('product/setProductId', id)
      this.$router.push({ name: 'productDetail', params: { productId: id } })
    },
    /**
     * 点击案例菜单跳转页面
     * @param id 案例id
     */
    projectDetailHandler (id) {
      this.$store.commit('product/setProjectId', id)
      this.$router.push({ name: 'productDemo', params: { projectId: id } })
    },
    /**
     * 查询产品和案例背景图
     */
    initBackground () {
      ApiWebProjectBackground().then(({data}) => {
        if (data && data.status === 0) {
          this.$set(this.background, 'banner', data.data.banner)
          this.$set(this.background, 'product', data.data.product)
          this.$set(this.background, 'project', data.data.project)
        }
      })
    }
  }
}
</script>
<style scoped lang="less">
  @import '../assets/style/index.less';
</style>

<style>
.pro-txt-box p{
  overflow: hidden;
    height: 100px;
    font-size: 20px;
    font-family: Microsoft YaHei;
    font-weight: 400;
    color: #666666;
    line-height: 36px;
}
</style>


// WEBPACK FOOTER //
// src/components/product.vue